var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fit-out__history" },
    [
      _vm.completedFitOuts.length
        ? [
            _vm._l(_vm.completedFitOuts, function (item, index) {
              return _c(
                "HKLLeftRight",
                {
                  key: index,
                  staticClass: "fit-out__history-item align-middle",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "fit-out__history-title",
                      on: {
                        click: function () {
                          return _vm.openPreviousHistory(item)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("tenantProjects.greenFitOut.title")) +
                          " " +
                          _vm._s(item.number) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("HKLGrayHint", [
                    _vm._v("\n        " + _vm._s(item.tipWording) + "\n      "),
                  ]),
                ],
                1
              )
            }),
            _vm._v(" "),
            _c("GreenFitOutPreviewSendModal", {
              ref: "previewSendModal",
              attrs: { previewData: _vm.previewFitOut },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isTenant && _vm.isUnderReview
        ? _c(
            "div",
            {
              staticClass:
                "fit-out__history-item row align-middle align-spaced",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "green-fitout-comments__title font-bold column small-6",
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("tenantProjects.greenFitOut.title")) +
                      "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "tip column small-6" }, [
                _c("span", { staticClass: "tip__text" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("tenantProjects.submission.comment.underReview")
                    )
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }